import { render } from "./PopisPreviewPage.vue?vue&type=template&id=c4480bbe"
import script from "./PopisPreviewPage.vue?vue&type=script&lang=js"
export * from "./PopisPreviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__